<div class="coverage-info">
  <div class="coverage-info-column" *ngIf="reserveCoverage != null">
    <div class="coverage-info-column-title">Reserve</div>
    <div class="coverage-info-column-value">{{reserveCoverage.reserve | numberFormat}} {{billingCurrency}}</div>
  </div>
  <div class="coverage-info-column" *ngIf="reserveCoverage != null">
    <div class="coverage-info-column-title">Remaining reserve</div>
    <div class="coverage-info-column-value" [ngClass]="remaining < 0 && 'coverage-info-column-value-below-zero'">{{remaining | numberFormat}} {{billingCurrency}}
    </div>
  </div>
  <div class="coverage-info-column" *ngIf="reserveCoverage != null">
    <div class="coverage-info-column-title">Settled claims cost</div>
    <div class="coverage-info-column-value">{{reserveCoverage.settled | numberFormat}} {{billingCurrency}}</div>
  </div>
  <div class="coverage-info-column coverage-info-last-column" *ngIf="reserveCoverage != null">
    <div class="coverage-info-column-title">Invoiced to customer</div>
    <div class="coverage-info-column-value">{{reserveCoverage.invoiced | numberFormat}} {{billingCurrency}}</div>
  </div>
</div>
